export const initialCompanyDetail = {
  nameOfTheCompany: "",
  dippCertificateNumber: "",
  cinNumber: "",
  typeOfTheCompany: "",
  companyCurrency: "INR - ₹",
  dateOfIncorporation: "",
  corporateOfficeAddress: "",
  companyEmailId: "",
  companyWebsite: "",
  companyLogoPath: "",
  doingBusinessAs: "",
  business: "",
  industry: [],
  category: [],
  nic: "",
  founders: [],
  directors: [],
};
